/* eslint-disable no-console */

import { register } from "register-service-worker";

export const PWA_UPDATE_AVAILABLE_EVENT = "gway:pwa-update-available";

let waitingWorker: ServiceWorker | null = null;

const buildRefreshUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("_update", Date.now().toString());
  return url.toString();
};

export const applyAppUpdate = async () => {
  if (!waitingWorker && "serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    waitingWorker = registration?.waiting ?? null;
  }

  if (!waitingWorker) {
    return false;
  }

  waitingWorker.postMessage({ type: "SKIP_WAITING" });
  return true;
};

export const forceRefreshApp = async () => {
  try {
    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
    }
  } catch (error) {
    console.error("Erro ao limpar cache da aplicação:", error);
  }

  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map((registration) => registration.unregister())
      );
    }
  } catch (error) {
    console.error("Erro ao remover service workers:", error);
  }

  window.location.replace(buildRefreshUrl());
};

export const checkForAppUpdate = async () => {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  const registration = await navigator.serviceWorker.getRegistration();

  if (!registration) {
    return;
  }

  if (registration.waiting) {
    waitingWorker = registration.waiting;
    window.dispatchEvent(
      new CustomEvent(PWA_UPDATE_AVAILABLE_EVENT, {
        detail: { registration },
      })
    );
    return;
  }

  await registration.update();
};

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // console.log(
      //   "App is being served from cache by a service worker.\n" +
      //     "For more details, visit https://goo.gl/AFskqB"
      // );
    },
    registered() {
      // console.log("Service worker has been registered.");
    },
    cached() {
      // console.log("Content has been cached for offline use.");
    },
    updatefound() {
      // console.log("New content is downloading.");
    },
    updated(registration) {
      waitingWorker = registration?.waiting ?? null;
      window.dispatchEvent(
        new CustomEvent(PWA_UPDATE_AVAILABLE_EVENT, {
          detail: { registration },
        })
      );
    },
    offline() {
      // console.log(
      //   "No internet connection found. App is running in offline mode."
      // );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
